import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { collections } from "../data/collections";
import { popularIds } from "../data/navigation";
import { products } from "../data/products";
import { formatPrice, shopifyImg } from "../utils/format";
import { container, ease } from "../utils/styles";
export function MegaMenu() {
  const popular = popularIds.map(id => products.find(p => p.id === id)).filter((p): p is NonNullable<typeof p> => Boolean(p));
  const featured = collections.filter(c => c.id === "verlichting" || c.id === "gepersonaliseerd");
  return <motion.div initial={{
    opacity: 0,
    y: -6
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -6
  }} transition={{
    duration: 0.18,
    ease
  }} className="absolute inset-x-0 top-full hidden border-b border-line bg-paper shadow-[0_24px_40px_-24px_rgba(21,21,21,0.18)] lg:block" data-id="element-251" data-mp="3prjk5so7tm4y">
      <div className={`${container} grid grid-cols-12 gap-10 py-10`} data-id="element-252" data-mp="3uyu8h87uk1y2">
        <div className="col-span-3" data-id="element-253" data-mp="3v05bv6xdr7on">
          <p className="text-sm text-muted" data-id="element-254" data-mp="3qxgzip9gjimx">Categorieën</p>
          <ul className="mt-4 space-y-1" data-id="element-255" data-mp="3qvxk10vmlbm7">
            {collections.map(c => <li key={c.id} data-id="element-256" data-mp="3lynxpu3j9g2l">
                <Link to={c.filter === "Alles" ? "/shop" : `/shop?categorie=${c.filter}`} className="group flex items-baseline justify-between py-1.5 text-lg font-medium text-ink" data-id="element-257" data-mp="3lzz0bql8shs4">
                  <span className="transition-colors duration-150 group-hover:text-gold-deep" data-id="element-258" data-mp="igm6e1igpcm1">{c.title}</span>
                  <span className="text-xs text-muted" data-id="element-259" data-mp="dkf9ey81nbg8">{c.count}</span>
                </Link>
              </li>)}
          </ul>
          <Link to="/shop" className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-ink underline-offset-4 hover:underline" data-id="element-260" data-mp="3t16eggvvtic">
            Shop alles <ArrowRightIcon className="h-3.5 w-3.5" data-id="element-261" data-mp="119zvhpzhuotq" />
          </Link>
        </div>

        <div className="col-span-3" data-id="element-262" data-mp="wflyjj56o9my">
          <p className="text-sm text-muted" data-id="element-263" data-mp="2qp0rzy5eswd5">Populair</p>
          <ul className="mt-4 space-y-3" data-id="element-264" data-mp="2qpkd1nqcw0ve">
            {popular.map(p => <li key={p.id} data-id="element-265" data-mp="2upkor0m2lxyr">
                <Link to={`/product/${p.id}`} className="group flex items-center gap-3" data-id="element-266" data-mp="2upufiqexw95i">
                  <img src={shopifyImg(p.image, 160)} alt="" className="h-14 w-14 rounded-lg bg-sand object-cover" data-id="element-267" data-mp="2gypo2blq6n69" />
                  <span className="min-w-0" data-id="element-268" data-mp="2lw7otepl9w36">
                    <span className="block truncate text-sm font-medium text-ink group-hover:underline group-hover:underline-offset-4" data-id="element-269" data-mp="270s25urc92gt">{p.name}</span>
                    <span className="text-xs text-muted" data-id="element-270" data-mp="2by1nay7p2ryu">{formatPrice(p.price)}</span>
                  </span>
                </Link>
              </li>)}
          </ul>
        </div>

        <div className="col-span-6 grid grid-cols-2 gap-5" data-id="element-271" data-mp="22zpz12uaw69k">
          {featured.map(c => <Link key={c.id} to={`/shop?categorie=${c.filter}`} className="group block" data-id="element-272" data-mp="3sf5whkyv43jm">
              <div className="aspect-[4/3] overflow-hidden rounded-xl bg-sand" data-id="element-273" data-mp="17l19aq4eeqx">
                <img src={shopifyImg(c.image, 700)} alt="" className="h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-274" data-mp="bd31x0af3wpn" />
              </div>
              <p className="mt-3 text-[15px] font-medium text-ink" data-id="element-275" data-mp="k4lhb8zji8ho">{c.title}</p>
              <p className="text-sm text-muted" data-id="element-276" data-mp="fdvdw1aocfpm">{c.description}</p>
            </Link>)}
        </div>
      </div>
    </motion.div>;
}